import { AuditMatch } from '@mi-front/core';

export function MatchName(p: { match: AuditMatch }) {
  const displayValue =
    (p.match.audio as any)?.id || p.match.audio?.customId || p.match.audio?.title;
  return <span className="font-weight-medium">{displayValue}</span>;
}
